
import { Component, Prop, Vue } from 'vue-property-decorator'
import Chart from 'chart.js/auto'
import { Tooltip } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import type { NumberFormat } from '@/types/observation'

// @ts-ignore
Tooltip.positioners.customPositioner = function (_elements, eventPosition) {
    return {
        x: eventPosition.x,
        y: eventPosition.y,
    }
}

@Component
export default class PieChart extends Vue {
    @Prop({ default: [] }) readonly data!: Array<any>
    @Prop() dataFormat!: NumberFormat
    @Prop() readonly height!: string
    @Prop() readonly width!: string
    @Prop() readonly title!: string

    chart = undefined as Chart | undefined

    formatLabel(value, context) {
        if (this.dataFormat === 'number') {
            return value
        } else if (this.dataFormat === 'percent') {
            let sum = context.dataset.data.reduce((a, b) => a + b)
            if (!sum) {
                return '0%'
            }
            return `${((value * 100) / sum).toFixed(1)}%`
        }
    }

    createChart() {
        let data = {
            labels: this.data.map((d) => d.label),
            datasets: [
                {
                    data: this.data.map((d) => d.data[0].x || d.data[0].y),
                    backgroundColor: this.data.map((d) => d.backgroundColor),
                    hoverOffset: 4,
                    datalabels: {
                        anchor: 'end',
                        align: 'start',
                    },
                },
            ],
        }

        const config = {
            type: 'pie',
            data,
            plugins: [ChartDataLabels],
            options: {
                plugins: {
                    legend: {
                        title: {
                            text: this.title,
                            display: Boolean(this.title),
                        },
                        labels: {
                            filter: function (item: any, chart: any) {
                                // filter out duplicated labels
                                return (
                                    chart.labels.findIndex(
                                        (label: string) => label === item.text
                                    ) === item.index
                                )
                            },
                        },
                    },
                    datalabels: {
                        display: !!this.dataFormat,
                        background: 'transparent',
                        color: 'white',
                        font: {
                            weight: 'bold',
                        },
                        formatter: this.formatLabel,
                    },
                    tooltip: {
                        caretSize: 0,
                        position: 'customPositioner',
                        boxPadding: 4,
                    },
                },
                onClick: (event, elements, chart) => {
                    this.$emit('elClicked', elements[0]?.index)
                },
            },
        }

        // @ts-ignore -- TS types mismatch
        this.chart = new Chart(this.$refs.chart, config)
    }

    mounted() {
        this.createChart()
    }

    beforeUnmount() {
        this.chart?.destroy()
    }
}
